import React from 'react';
import { isEditorActive, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { isEmptyResponse } from '../../../utils/checkEmptyResponse';
import EmptyApiDataMessage from '../emptyApiDataMessage';
import ExperienceEditorComponentPlaceholder from '../experienceEditorComponentPlaceholder';
import useExperienceEditorPlaceholder from '../../../hooks/useExperienceEditorPlaceholder';
import { TProductFeatureComponentProps } from './types/productFeatureComponent.types';
import MobileSeriesDetails from './components/mobileSeriesDetails';
import useMediaQuery from '../../../hooks/useMediaQuery';
import DesktopSeriesDetails from './components/desktopSeriesDetails';
import UnreleasedComponent from '../unreleasedComponent';
import breakpoints from '../../../constants/breakpoints.constants';
import '../../../styles/@shared/feature-module.scss';
import './styles.scss';

const ProductFeatureComponent = (props: TProductFeatureComponentProps) => {
  const apiResponse =
    isEmptyResponse(props) && props?.fields?.apiData?.innerComponents && props?.fields?.apiData?.innerComponents?.length > 0;
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <ExperienceEditorComponentPlaceholder image={props?.fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />
    );
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  if (isDesktop) {
    return <DesktopSeriesDetails {...props} />;
  } else {
    return <MobileSeriesDetails {...props} showImageOverlay={props?.showImageOverlay} />;
  }
};

export default withSitecoreContext()(ProductFeatureComponent);
